/* 有料ラッピング。購入手続きの送信制御は gift-auto-add.js のみが担当する。 */
(() => {
  'use strict';

  const cfg = window.giftWrapConfig;
  if (!cfg || !cfg.enabled || !cfg.variantId) return;

  const source = 'gift-wrap';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let lastCart = null;
  let queue = Promise.resolve();
  let jobs = 0;
  let operationWanted = null;
  let errorText = '';
  let statusText = '';
  let feedbackSelection = null;
  let checkoutCheck = false;
  let displayDirty = false;
  let displayRepairPending = false;

  const isWrap = (item) => Number(item.variant_id) === Number(cfg.variantId);
  const wrapLines = (cart) => cart.items.filter(isWrap);
  // 自動プレゼントとラッピング商品自身は、同時購入する通常商品に数えない。
  const hasProduct = (cart) => cart.items.some((item) =>
    Number(item.product_id) !== Number(cfg.productId) && !(item.properties && item.properties._auto_gift)
  );

  async function request(url, body) {
    const response = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : { cache: 'no-store' }),
    });
    const data = await response.json();
    if (!response.ok || data.errors || data.status >= 400) throw new Error('カートを更新できませんでした。');
    return data;
  }

  async function getCart() {
    const cart = await request(root + 'cart.js');
    if (!Array.isArray(cart.items)) throw new Error('カートを確認できませんでした。');
    lastCart = cart;
    return cart;
  }

  function setText(element, text) {
    if (element.textContent !== text) element.textContent = text;
  }

  function render() {
    document.querySelectorAll('[data-gift-wrap-notice]').forEach((element) => {
      element.hidden = cfg.isWholesale;
    });
    const selected = lastCart && wrapLines(lastCart).length > 0;
    const hasNormalProduct = lastCart && hasProduct(lastCart);
    if (lastCart && feedbackSelection !== null && feedbackSelection !== !!selected) {
      statusText = '';
      feedbackSelection = null;
    }
    document.querySelectorAll('[data-gift-wrap-option]').forEach((element) => {
      element.hidden = cfg.isWholesale;
      const checkbox = element.querySelector('[data-gift-wrap-checkbox]');
      checkbox.checked = operationWanted === null ? !!selected : operationWanted;
      checkbox.disabled = cfg.isWholesale || !lastCart || jobs > 0 ||
        (!selected && (!cfg.available || !hasNormalProduct));
      element.setAttribute('aria-busy', jobs > 0 ? 'true' : 'false');
      const note = !selected && !cfg.available ? '現在、ラッピングを追加できません。'
        : !hasNormalProduct ? '通常商品と一緒にご購入ください。' : '1注文につき1点までご利用いただけます。';
      setText(element.querySelector('[data-gift-wrap-note]'), note);
      const progress = operationWanted === true ? 'ラッピングを追加しています…'
        : operationWanted === false ? 'ラッピングを削除しています…' : 'カート内容を確認しています…';
      setText(element.querySelector('[data-gift-wrap-status]'), jobs > 0 ? progress : statusText);
      const error = element.querySelector('[data-gift-wrap-error]');
      setText(error, errorText);
      error.hidden = !errorText;
    });
  }

  function sectionTargets() {
    const cartItems = document.querySelector('cart-items');
    if (cartItems) return cartItems.getSectionsToRender();
    // 商品ページ・追加通知では、自動補正時に件数だけを最新にする。
    return ['cart-icon-bubble', 'cart-notification-button']
      .filter((id) => document.getElementById(id))
      .map((id) => ({ id, section: id, selector: '.shopify-section' }));
  }

  function sectionRequest() {
    return {
      sections: sectionTargets().map((target) => target.section),
      sections_url: root + 'cart',
    };
  }

  async function getSections(targets) {
    if (!targets.length) return {};
    const url = new URL(root + 'cart', window.location.origin);
    url.searchParams.set('sections', targets.map((target) => target.section).join(','));
    // /cart は Accept: application/json で通常のカートJSONを返すため、セクション取得では指定しない。
    const response = await fetch(url.toString(), { cache: 'no-store' });
    if (!response.ok) throw new Error('セクションを取得できませんでした。');
    return response.json();
  }

  function verifyItems(container, cart) {
    const inputs = [...container.querySelectorAll('input[data-quantity-variant-id]')];
    const actual = new Map();
    const expected = new Map();
    inputs.forEach((input) => {
      const id = Number(input.dataset.quantityVariantId);
      actual.set(id, (actual.get(id) || 0) + Number(input.value));
    });
    cart.items.forEach((item) => {
      const id = Number(item.variant_id);
      expected.set(id, (expected.get(id) || 0) + item.quantity);
    });
    if (inputs.length !== cart.items.length || actual.size !== expected.size ||
      [...expected].some(([id, quantity]) => actual.get(id) !== quantity)) {
      throw new Error('商品一覧の反映を確認できませんでした。');
    }
  }

  async function refresh(cart, suppliedSections) {
    try {
      const targets = sectionTargets();
      const sections = suppliedSections || await getSections(targets);
      // 全セクションを先に検証し、nullや描画対象欠落を成功扱いにしない。
      const contents = targets.map((target) => {
        const html = sections[target.section];
        if (typeof html !== 'string') throw new Error('セクションを取得できませんでした。');
        const content = new DOMParser().parseFromString(html, 'text/html').querySelector(target.selector);
        const rootElement = document.getElementById(target.id);
        if (!content || !rootElement) throw new Error('描画対象が見つかりませんでした。');
        const element = rootElement.querySelector(target.selector) || rootElement;
        if (target.id === 'main-cart-items') verifyItems(content, cart);
        return { target, content, element };
      });
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        // Dawnの数量変更と同じHTML差し替えを使用する。数量変更自体は呼ばない。
        cartItems.renderSections({ ...cart, sections });
        cartItems.classList.toggle('is-empty', cart.item_count === 0);
        document.getElementById('main-cart-footer').classList.toggle('is-empty', cart.item_count === 0);
        verifyItems(document.getElementById('main-cart-items'), cart);
      } else {
        contents.forEach(({ element, content }) => { element.innerHTML = content.innerHTML; });
      }
      // 一覧に加え、小計・件数も実DOMへの反映を確認してから成功とする。
      contents.forEach(({ target, content, element }) => {
        if (target.id === 'main-cart-items') return;
        if (element.innerHTML !== content.innerHTML) throw new Error('カート表示の反映を確認できませんでした。');
      });
      displayDirty = false;
      if (!checkoutCheck && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        // カート自身は描画済み。既存source判定で二重取得を避け、他の購読者へ通知する。
        await publish(PUB_SUB_EVENTS.cartUpdate, { source: cartItems ? 'cart-items' : source, origin: source, cartData: cart });
      }
      render();
    } catch (error) {
      displayDirty = true;
      error.displayUpdate = true;
      throw error;
    }
  }

  async function reconcile(wanted) {
    let cart = await getCart();
    const lines = wrapLines(cart);
    const eligible = !cfg.isWholesale && hasProduct(cart);
    const updates = {};
    let response = null;

    lines.forEach((item, index) => {
      const quantity = eligible && wanted !== false && index === 0 ? 1 : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    if (Object.keys(updates).length) {
      displayDirty = true;
      response = await request(root + 'cart/update.js', { updates, ...sectionRequest() });
    }
    if (eligible && wanted === true && !lines.length) {
      if (!cfg.available) throw new Error('ラッピングは現在追加できません。');
      // properties は付けず、専用の単一variantを通常の商品として追加する。
      displayDirty = true;
      response = await request(root + 'cart/add.js', {
        items: [{ id: cfg.variantId, quantity: 1 }], ...sectionRequest(),
      });
    }
    if (response) cart = await getCart();
    const quantity = wrapLines(cart).reduce((total, item) => total + item.quantity, 0);
    const allowed = !cfg.isWholesale && hasProduct(cart);
    if (quantity > 1 || (!allowed && quantity) || (wanted === false && quantity) ||
      (wanted === true && allowed && quantity !== 1)) {
      throw new Error('ラッピングの状態を確認できませんでした。');
    }
    // 別のカート更新の古い応答で一覧が上書きされた場合も、再追加せず表示を直す。
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems && !displayDirty) {
      try { verifyItems(cartItems, cart); } catch (_) { displayDirty = true; }
    }
    if (response || displayDirty || wanted !== undefined) await refresh(cart, response && response.sections);
    render();
    return { ok: true, cart };
  }

  function enqueue(task) {
    jobs += 1;
    render();
    const operation = queue.then(task).catch(async (error) => {
      operationWanted = null;
      statusText = '';
      feedbackSelection = null;
      errorText = error.displayUpdate
        ? 'カート表示の更新に失敗しました。最新のカート内容をご確認ください。'
        : 'ラッピングの更新・確認に失敗しました。カートの内容をご確認ください。';
      // 表示復旧はGETだけで行う。保存済みの商品を再追加しない。
      try {
        const cart = await getCart();
        await refresh(cart);
      } catch (_) {
        errorText = '最新のカート表示を確認できませんでした。時間をおいて再度お試しください。';
      }
      return { ok: false, blockCheckout: true };
    }).finally(() => {
      jobs -= 1;
      render();
    });
    queue = operation;
    return operation;
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-gift-wrap-checkbox]')) return;
    if (jobs > 0 || cfg.isWholesale) { render(); return; }
    const wanted = event.target.checked;
    operationWanted = wanted;
    errorText = '';
    statusText = '';
    feedbackSelection = null;
    displayRepairPending = false;
    enqueue(() => reconcile(wanted)).then((result) => {
      operationWanted = null;
      if (result.ok) {
        feedbackSelection = wanted;
        statusText = wanted ? 'ラッピングを追加しました。' : 'ラッピングを削除しました。';
      }
      render();
    });
  });

  async function waitForIdle() {
    const current = queue;
    await current;
    if (current !== queue) await waitForIdle();
  }

  window.giftWrap = {
    prepareCheckout() {
      checkoutCheck = true;
      return waitForIdle();
    },
    finishCheckout() {
      checkoutCheck = false;
    },
    beforeCheckout() {
      return enqueue(() => reconcile());
    },
  };

  function boot() {
    enqueue(() => reconcile());
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event && (event.source === source || event.origin === source)) return;
        displayRepairPending = false;
        // publishの完了待ちと相互待機しないよう、購読側ではキューを返さない。
        enqueue(() => reconcile());
      });
    }
    // DawnによるHTML差し替え後にも直近の状態を表示する。
    new MutationObserver((records) => {
      if (records.some((record) => Array.from(record.addedNodes).some((node) =>
        node.nodeType === 1 && (node.matches('[data-gift-wrap-option], [data-gift-wrap-notice]') ||
          node.querySelector('[data-gift-wrap-option], [data-gift-wrap-notice]'))
      ))) render();
      // プレゼント側の遅い応答が古い商品一覧を戻した場合も、保存済みカートで表示を補正する。
      const cartItems = document.getElementById('main-cart-items');
      const itemDisplayChanged = records.some((record) =>
        (record.target.closest && record.target.closest('[data-gift-wrap-option]')) ||
        Array.from(record.addedNodes).some((node) => node.nodeType === 1 &&
          (node.matches('input[data-quantity-variant-id]') || node.querySelector('input[data-quantity-variant-id]')))
      );
      if (lastCart && jobs === 0 && cartItems && itemDisplayChanged && !displayRepairPending) {
        try { verifyItems(cartItems, lastCart); } catch (_) {
          displayDirty = true;
          displayRepairPending = true;
          enqueue(() => reconcile()).then((result) => {
            if (result.ok) { displayRepairPending = false; errorText = ''; render(); }
            // 失敗時は、新しいカート操作まで補正を重ねない。
          });
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
